'use client';
import { resolverService } from "../resolvers/resolverService";
import useSWR from "swr";
const useSWRGas = (address, network, token, amount, wallet) => {
    const { data: gasData, error: gasError, isLoading } = useSWR((network && address) ? `/gases/${address}/${network.name}/${token?.symbol}${amount ? `/${amount}` : ''}` : null, () => {
        if (!network || !token || !address)
            return;
        return resolverService.getGasResolver().getGas({ address, network, token, amount: Number(amount), wallet });
    }, { refreshInterval: 60000 });
    return {
        gasData,
        isGasLoading: isLoading,
        gasError: gasError
    };
};
export default useSWRGas;
